import flowRight from 'lodash/flowRight'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { actions as LKModalActions } from '../shared/LKModal'
import { getSrc, getContentType, getError } from './reducers/selectors'
import { fetchFile } from './reducers/actions'
import { downloadRemote } from './fileDetails.actions'
import { viewFile } from 'src/store/linkedFiles'

export default flowRight(
  withRouter,
  connect(
    (state) => ({
      src: getSrc(state),
      contentType: getContentType(state),
      error: getError(state),
    }),
    (dispatch) => ({
      // @ts-ignore
      fileDetails: (params) => dispatch(viewFile(params)),
      fetchFile: (ID, hash, callback) => dispatch(fetchFile({ ID, hash }, callback)),
      openErrorModal: (message) => dispatch(LKModalActions.openError(message)),
      // @ts-ignore
      downloadRemote: (params) => dispatch(downloadRemote(params)),
    }),
  ),
)
